export var UiSpacing = /* @__PURE__ */ ((UiSpacing2) => {
  UiSpacing2["SP_2XS"] = "4px";
  UiSpacing2["SP_XS"] = "8px";
  UiSpacing2["SP_S"] = "12px";
  UiSpacing2["SP_M"] = "16px";
  UiSpacing2["SP_L"] = "20px";
  UiSpacing2["SP_XL"] = "24px";
  UiSpacing2["SP_2XL"] = "32px";
  UiSpacing2["SP_3XL"] = "40px";
  UiSpacing2["SP_4XL"] = "48px";
  UiSpacing2["SP_5XL"] = "56px";
  UiSpacing2["SP_6XL"] = "64px";
  UiSpacing2["SP_7XL"] = "72px";
  return UiSpacing2;
})(UiSpacing || {});
